import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import CorporateNumber from "./CorporateNumber";
import LabelsContainer from "./LabelsContainer";

const styles = () => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
});

const CorporateNumberAndLabels = ({ classes, item }) => {
  return (
    <div className={classes.root}>
      <CorporateNumber item={item} />
      <LabelsContainer item={item} />
    </div>
  );
};

CorporateNumberAndLabels.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(CorporateNumberAndLabels);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/CorporateNumberAndLabels.jsx